/* Essencraft Stage 2 smart offer — after quiz destination engagement. */
(function () {
  'use strict';

  var CONCERN_BODY = {
    resin: {
      batch_testing: 'You’ve had a chance to review the testing. If the traditional resin format feels right, choose how you want to start.',
      sensory: 'Now that you know what to expect from the resin itself, choose how you want to start.',
      usage: 'Now that you’ve reviewed how the routine works, choose how you want to start.',
      value_supply: 'Now that you’ve reviewed the quantity and replenishment interval, choose the purchase option that fits you.',
      subscription_control: 'Now that you’ve reviewed how Resin Auto-Replenishment works, choose how you want to start.'
    },
    capsules: {
      formula: 'Now that you’ve reviewed the formula, choose how you want to start.',
      batch_testing: 'You’ve had a chance to review the capsule testing. If capsules feel right, choose how you want to start.',
      routine_supply: 'Now that you’ve reviewed the routine and supply, choose how you want to start.',
      comparison: 'Now that you’ve compared the formats, choose how you want to start with capsules.',
      subscription_control: 'Now that you’ve reviewed capsule replenishment, choose how you want to start.'
    },
    atlas_x: {
      formula: 'Now that you’ve reviewed the formula, choose how you want to start.',
      batch_testing: 'You’ve had a chance to review the testing. Choose how you want to start with Atlas X.',
      routine_supply: 'Now that you’ve reviewed the routine, choose how you want to start.',
      comparison: 'Now that you’ve compared the products, choose how you want to start.',
      subscription_control: 'Now that you’ve reviewed replenishment terms, choose how you want to start.'
    }
  };

  var CONCERN_SELECTORS = {
    batch_testing: ['#ec-testing-batch', '#ec-independent-testing', '[data-ec-concern-section="batch_testing"]'],
    sensory: ['#ec-expectations', '[data-ec-concern-section="sensory"]'],
    usage: ['#ec-how-to-use', '[data-ec-concern-section="usage"]'],
    value_supply: ['#ec-format-fit', '#ec-primary-purchase', '[data-ec-concern-section="value_supply"]'],
    subscription_control: ['#ec-primary-purchase', '[data-rc-widget]', '[data-ec-concern-section="subscription_control"]'],
    formula: ['#ec-source-or-formula', '[data-ec-concern-section="formula"]'],
    routine_supply: ['#ec-how-to-use', '[data-ec-concern-section="routine_supply"]'],
    comparison: ['#ec-product-comparison', '[data-ec-concern-section="comparison"]'],
    organic_source: ['#ec-source-or-formula', '[data-ec-concern-section="organic_source"]'],
    process: ['#ec-source-or-formula', '[data-ec-concern-section="process"]'],
    heavy_metals: ['#ec-testing-batch', '#ec-independent-testing', '[data-ec-concern-section="heavy_metals"]']
  };

  var BLOCKED_PATH = /(account|login|register|orders|addresses|challenge|apps\/|tools\/|cancel|subscription|checkout|cart)/i;
  var IDLE_MS_DEFAULT = 8000;
  var instance = null;

  function getParam(name) {
    try { return new URLSearchParams(window.location.search).get(name); }
    catch (e) { return null; }
  }

  function utms() {
    return {
      utm_source: getParam('utm_source') || '',
      utm_medium: getParam('utm_medium') || '',
      utm_campaign: getParam('utm_campaign') || ''
    };
  }

  function money(cents) {
    var n = Number(cents);
    if (!isFinite(n) || n <= 0) return '';
    try {
      return (n / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      });
    } catch (e) {
      return '$' + (n / 100).toFixed(2);
    }
  }

  function isUsablePrice(value) {
    if (value == null) return false;
    var s = String(value).trim();
    if (!s || s === '—' || s === '-') return false;
    if (/^\$?0+(?:[\.,]0+)?$/.test(s.replace(/\s/g, ''))) return false;
    var n = parseFloat(s.replace(/[^0-9.]/g, ''));
    return isFinite(n) && n > 0;
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function validEmail(value) {
    var v = (value || '').trim();
    if (v.length < 5 || v.length > 254) return false;
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  }

  function addDays(days) {
    var d = new Date();
    d.setDate(d.getDate() + (parseInt(days, 10) || 0));
    try {
      return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
    } catch (e) {
      return d.toISOString().slice(0, 10);
    }
  }

  function cartHasItems() {
    try {
      if (window.Shopify && Shopify.cart && typeof Shopify.cart.item_count === 'number') {
        return Shopify.cart.item_count > 0;
      }
    } catch (e) {}
    return false;
  }

  function readFunnel() {
    if (window.ECQuizFunnel && ECQuizFunnel.read) return ECQuizFunnel.read();
    try {
      return JSON.parse(localStorage.getItem('ec_quiz_funnel_v3') || 'null');
    } catch (e) {
      return null;
    }
  }

  function writeFunnel(partial) {
    if (window.ECQuizFunnel && ECQuizFunnel.write) return ECQuizFunnel.write(partial);
    try {
      var cur = readFunnel() || {};
      var next = Object.assign({}, cur, partial || {});
      localStorage.setItem('ec_quiz_funnel_v3', JSON.stringify(next));
      return next;
    } catch (e) {
      return null;
    }
  }

  function readSession() {
    if (window.ECQuizFunnel && ECQuizFunnel.readSession) return ECQuizFunnel.readSession();
    try { return JSON.parse(sessionStorage.getItem('ec_quiz_funnel_session_v3') || '{}'); }
    catch (e) { return {}; }
  }

  function writeSession(partial) {
    if (window.ECQuizFunnel && ECQuizFunnel.writeSession) return ECQuizFunnel.writeSession(partial);
    try {
      var cur = readSession();
      var next = Object.assign({}, cur, partial || {});
      sessionStorage.setItem('ec_quiz_funnel_session_v3', JSON.stringify(next));
      return next;
    } catch (e) {
      return {};
    }
  }

  function hydrateFromQuery(state) {
    var route = getParam('ec_quiz_route');
    var concern = getParam('ec_quiz_concern');
    var source = getParam('ec_quiz_source');
    if (!route && !concern) return state;
    var next = Object.assign({}, state || {}, {
      version: (state && state.version) || '3',
      route: route || (state && state.route) || null,
      concern: concern || (state && state.concern) || null,
      quizCompleted: true,
      destinationReached: true
    });
    if (source) next.quizSource = source;
    if (!next.commercialProduct && next.route && next.route !== 'testing_first') {
      next.commercialProduct = next.route;
    }
    if (next.route === 'testing_first') next.commercialProduct = next.commercialProduct || null;
    return writeFunnel(next) || next;
  }

  function ECSmartOffer(root) {
    this.root = root;
    var cfgEl = root.querySelector('script[data-ec-smart-offer-config]');
    if (!cfgEl) return;
    try { this.config = JSON.parse(cfgEl.textContent); }
    catch (e) { return; }

    this.modal = root.querySelector('[data-ec-smart-offer]');
    this.manual = root.querySelector('[data-ec-smart-offer-manual]');
    this.shown = false;
    this.eligibleFired = false;
    this.engagedFired = false;
    this.destinationViewedFired = false;
    this.sectionViewedFired = false;
    this.guideViewedFired = false;
    this.guideMainPointsFired = false;
    this.guideEngagedFired = false;
    this.submitting = false;
    this.start = Date.now();
    this.activeMs = 0;
    this.activeLast = null;
    this.isActivelyReading = false;
    this.windowBlurred = false;
    this.lastInteractionAt = Date.now();
    this.idleMs = (this.config && this.config.idleSeconds ? this.config.idleSeconds : 8) * 1000 || IDLE_MS_DEFAULT;
    this.maxScroll = 0;
    this.concernSectionViewed = false;
    this.relevantInteraction = false;
    this.mainPointsMs = 0;
    this.mainPointsVisible = false;
    this.mainPointsLast = null;
    this.eventsFired = {};
    this.livePrices = {};

    this.state = hydrateFromQuery(readFunnel());
    if (!this.state || !this.state.quizCompleted) {
      this.updateManual(false);
      return;
    }

    var pageProduct = this.pageCommercialProduct();
    if (pageProduct === 'conflict') {
      this.updateManual(false);
      return;
    }
    if (pageProduct === 'none') {
      writeFunnel({ commercialProduct: null });
      this.state = readFunnel();
    } else if (pageProduct && this.state.commercialProduct && pageProduct !== this.state.commercialProduct) {
      this.updateManual(false);
      return;
    } else if (pageProduct && !this.state.commercialProduct && this.state.route !== 'testing_first') {
      writeFunnel({ commercialProduct: pageProduct });
      this.state = readFunnel();
    }

    writeFunnel({ destinationReached: true });
    this.trackOnce('quiz_destination_viewed', { destination: location.pathname + location.hash });
    if (document.querySelector('[data-ec-main-points], [data-ec-guide-hero], [data-ec-guide-quick]')) {
      this.trackOnce('guide_viewed', { destination: location.pathname + location.hash });
    }

    if (BLOCKED_PATH.test(location.pathname)) {
      this.updateManual(false);
      return;
    }

    this.bindActiveReading();
    this.bindEngagement();
    this.bindUi();
    this.updateManual(true);
    this.tick = window.setInterval(this.evaluate.bind(this), 1000);
    this.evaluate();
  };

  ECSmartOffer.prototype.markInteraction = function () {
    this.lastInteractionAt = Date.now();
    this.windowBlurred = false;
    this.syncActiveReading();
  };

  ECSmartOffer.prototype.canCountActiveReading = function () {
    // Count only when visible, focused, and not idle (>8s without interaction).
    if (document.visibilityState !== 'visible' || document.hidden) return false;
    if (this.windowBlurred) return false;
    try {
      if (typeof document.hasFocus === 'function' && !document.hasFocus()) return false;
    } catch (e) {}
    if ((Date.now() - this.lastInteractionAt) > this.idleMs) return false;
    return true;
  };

  ECSmartOffer.prototype.syncActiveReading = function () {
    var now = Date.now();
    var should = this.canCountActiveReading();
    if (this.isActivelyReading && this.activeLast) {
      this.activeMs += Math.max(0, now - this.activeLast);
    }
    this.isActivelyReading = should;
    this.activeLast = should ? now : null;
  };

  ECSmartOffer.prototype.activeReadingSeconds = function () {
    this.syncActiveReading();
    return this.activeMs / 1000;
  };

  ECSmartOffer.prototype.bindActiveReading = function () {
    var self = this;
    var onInteract = function () { self.markInteraction(); };
    ['scroll', 'mousemove', 'mousedown', 'keydown', 'touchstart', 'wheel', 'pointerdown'].forEach(function (evt) {
      window.addEventListener(evt, onInteract, { passive: true });
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) self.windowBlurred = true;
      self.syncActiveReading();
      self.evaluate();
    });
    window.addEventListener('blur', function () {
      self.windowBlurred = true;
      self.syncActiveReading();
      self.evaluate();
    });
    window.addEventListener('focus', function () {
      self.windowBlurred = false;
      self.markInteraction();
      self.evaluate();
    });
    this.markInteraction();
  };

  ECSmartOffer.prototype.pageCommercialProduct = function () {
    var el = document.querySelector('[data-ec-guide-commercial-product]');
    if (!el) return null;
    var v = (el.getAttribute('data-ec-guide-commercial-product') || '').trim();
    if (!v || v === 'none') return 'none';
    if (['resin', 'capsules', 'atlas_x'].indexOf(v) === -1) return 'conflict';
    return v;
  };

  ECSmartOffer.prototype.track = function (name, extra) {
    var u = utms();
    var s = this.state || {};
    var payload = Object.assign({
      route: s.route || null,
      concern: s.concern || null,
      commercial_product: s.commercialProduct || null,
      destination: location.pathname + location.hash,
      dwell_time: Math.round(this.activeReadingSeconds ? this.activeReadingSeconds() : ((Date.now() - this.start) / 1000)),
      wall_time: Math.round((Date.now() - this.start) / 1000),
      scroll_depth: Math.round(this.maxScroll),
      relevant_interaction: !!this.relevantInteraction,
      offer_type: this.offerType(),
      utm_source: u.utm_source,
      utm_medium: u.utm_medium,
      utm_campaign: u.utm_campaign
    }, extra || {});
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('essencraft:' + name, payload);
      }
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'ec_' + name }, payload));
    } catch (e) {}
  };

  ECSmartOffer.prototype.trackOnce = function (name, extra) {
    if (this.eventsFired[name]) return;
    this.eventsFired[name] = true;
    this.track(name, extra);
  };

  ECSmartOffer.prototype.offerType = function () {
    if (!this.state) return null;
    if (!this.state.commercialProduct) return 'soft_progression';
    return 'product_offer';
  };

  ECSmartOffer.prototype.commerceFor = function (productKey) {
    var fromState = this.state && this.state.commerce;
    if (fromState && this.state.commercialProduct === productKey) return fromState;
    var map = (this.config.products || {})[productKey];
    return map || null;
  };

  ECSmartOffer.prototype.bindEngagement = function () {
    var self = this;
    window.addEventListener('scroll', function () {
      var doc = document.documentElement;
      var scrollTop = window.scrollY || doc.scrollTop || 0;
      var height = Math.max(doc.scrollHeight - window.innerHeight, 1);
      self.maxScroll = Math.max(self.maxScroll, (scrollTop / height) * 100);
      self.checkConcernSection();
      self.evaluate();
    }, { passive: true });

    document.addEventListener('click', function (e) {
      var t = e.target.closest('a, button, summary, [data-ec-report-link], .ec-testing__report-button');
      if (!t) return;
      var href = (t.getAttribute('href') || '').toLowerCase();
      if (
        t.matches('summary') ||
        t.closest('details') ||
        href.indexOf('pdf') > -1 ||
        href.indexOf('report') > -1 ||
        t.classList.contains('ec-testing__report-button') ||
        t.closest('#ec-testing-batch, #ec-how-to-use, #ec-source-or-formula, #ec-expectations, #ec-product-comparison, #ec-primary-purchase, [data-ec-main-points]')
      ) {
        self.relevantInteraction = true;
        self.evaluate();
      }
    }, true);

    this.checkConcernSection();
    this.bindMainPointsObserver();
    if ('IntersectionObserver' in window) {
      var sels = CONCERN_SELECTORS[this.state.concern] || [];
      sels.forEach(function (sel) {
        var el = document.querySelector(sel);
        if (!el) return;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              self.concernSectionViewed = true;
              if (!self.sectionViewedFired) {
                self.sectionViewedFired = true;
                self.trackOnce('quiz_concern_section_viewed', { section: sel });
                writeFunnel({ concernSectionViewed: true });
              }
              self.evaluate();
            }
          });
        }, { threshold: 0.35 });
        io.observe(el);
      });
    }
  };

  ECSmartOffer.prototype.bindMainPointsObserver = function () {
    var self = this;
    var el = document.querySelector('[data-ec-main-points]');
    if (!el) return;
    if (!('IntersectionObserver' in window)) {
      // Fail closed without IO: never count main-points as consumed.
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var now = Date.now();
        if (self.mainPointsVisible && self.mainPointsLast) {
          self.mainPointsMs += Math.max(0, now - self.mainPointsLast);
        }
        self.mainPointsVisible = !!(entry.isIntersecting && entry.intersectionRatio >= 0.5);
        self.mainPointsLast = now;
        if (self.mainPointsVisible) {
          self.concernSectionViewed = true;
        }
        self.evaluate();
      });
    }, { threshold: [0, 0.5, 0.75, 1] });
    io.observe(el);
  };

  ECSmartOffer.prototype.mainPointsConsumed = function () {
    var need = (this.config && this.config.mainPointsMs) || 3000;
    if (this.mainPointsVisible && this.mainPointsLast) {
      this.mainPointsMs += Math.max(0, Date.now() - this.mainPointsLast);
      this.mainPointsLast = Date.now();
    }
    // Guide pages: require data-ec-main-points consumption.
    if (document.querySelector('[data-ec-main-points]')) {
      return this.mainPointsMs >= need;
    }
    // PDP / blog fallback destinations: require concern section or relevant interaction
    // (scroll alone is never enough).
    return !!(this.concernSectionViewed || this.relevantInteraction);
  };

  ECSmartOffer.prototype.checkConcernSection = function () {
    var sels = CONCERN_SELECTORS[(this.state && this.state.concern) || ''] || [];
    for (var i = 0; i < sels.length; i++) {
      var el = document.querySelector(sels[i]);
      if (!el) continue;
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.85 && rect.bottom > 0) {
        this.concernSectionViewed = true;
        if (!this.sectionViewedFired) {
          this.sectionViewedFired = true;
          this.trackOnce('quiz_concern_section_viewed', { section: sels[i] });
          writeFunnel({ concernSectionViewed: true });
        }
        break;
      }
    }
  };

  ECSmartOffer.prototype.bindUi = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      var t = e.target.closest([
        '[data-ec-so-close]',
        '[data-ec-so-keep-reading]',
        '[data-ec-so-subscribe]',
        '[data-ec-so-onetime]',
        '[data-ec-so-confirm-submit]',
        '[data-ec-so-confirm-cancel]',
        '[data-ec-so-email-submit]',
        '[data-ec-so-soft]',
        '[data-ec-smart-offer-manual-open]'
      ].join(','));
      if (!t) return;

      if (t.hasAttribute('data-ec-so-close') || t.hasAttribute('data-ec-so-keep-reading')) {
        e.preventDefault();
        self.dismiss(t.hasAttribute('data-ec-so-keep-reading') ? 'keep_reading' : 'dismiss');
        return;
      }
      if (t.hasAttribute('data-ec-smart-offer-manual-open')) {
        e.preventDefault();
        self.show(true);
        return;
      }
      if (t.hasAttribute('data-ec-so-subscribe')) {
        e.preventDefault();
        self.openConfirm();
        return;
      }
      if (t.hasAttribute('data-ec-so-onetime')) {
        e.preventDefault();
        self.addOneTime();
        return;
      }
      if (t.hasAttribute('data-ec-so-confirm-submit')) {
        e.preventDefault();
        self.confirmSubscription();
        return;
      }
      if (t.hasAttribute('data-ec-so-confirm-cancel')) {
        e.preventDefault();
        self.closeConfirm();
        return;
      }
      if (t.hasAttribute('data-ec-so-email-submit')) {
        e.preventDefault();
        self.submitEmail();
        return;
      }
      if (t.hasAttribute('data-ec-so-soft')) {
        var product = t.getAttribute('data-ec-so-soft');
        if (product === 'comparison') return;
        e.preventDefault();
        writeFunnel({ commercialProduct: product });
        self.state = readFunnel();
        var urls = (self.state && self.state.productUrls) || {};
        var href = urls[product] || t.getAttribute('href');
        if (href) window.location.href = window.ECCanonicalProductUrl ? window.ECCanonicalProductUrl(href) : href;
      }
    });
  };

  ECSmartOffer.prototype.justClosedQuiz = function () {
    try {
      var ts = parseInt(sessionStorage.getItem('ec_quiz_just_closed') || '0', 10);
      return ts && (Date.now() - ts) < 4000;
    } catch (e) {
      return false;
    }
  };

  ECSmartOffer.prototype.isSuppressed = function () {
    var sess = readSession();
    if (sess.smartOfferDismissed || sess.smartOfferShownOnce) return true;
    if (this.state && this.state.smartOfferDismissed) return true;
    if (cartHasItems()) return true;
    if (BLOCKED_PATH.test(location.pathname)) return true;
    if (this.justClosedQuiz()) return true;
    if (window.Shopify && Shopify.designMode) return true;
    return false;
  };

  ECSmartOffer.prototype.pageOfferMeta = function () {
    var dwellEl = document.querySelector('[data-ec-so-dwell]');
    var introEl = document.querySelector('[data-ec-so-intro]');
    var softEl = document.querySelector('[data-ec-so-soft-heading]');
    var dwell = 0;
    if (dwellEl) {
      dwell = parseInt(dwellEl.getAttribute('data-ec-so-dwell') || '0', 10) || 0;
    }
    return {
      dwell: dwell,
      intro: introEl ? (introEl.getAttribute('data-ec-so-intro') || '').trim() : '',
      softHeading: softEl ? (softEl.getAttribute('data-ec-so-soft-heading') || '').trim() : ''
    };
  };

  ECSmartOffer.prototype.thresholds = function () {
    var c = this.config || {};
    var isSubConcern = this.state && this.state.concern === 'subscription_control';
    var page = this.pageOfferMeta();
    var dwell = isSubConcern ? (c.subscriptionDwellSeconds || 10) : (c.dwellSeconds || 20);
    if (page.dwell > 0) dwell = page.dwell;
    return {
      dwell: dwell,
      mainPointsMs: c.mainPointsMs || 3000
    };
  };

  ECSmartOffer.prototype.engagementMet = function () {
    var t = this.thresholds();
    var dwellOk = this.activeReadingSeconds() >= t.dwell;
    if (!dwellOk) return false;
    // Scroll depth alone never proves the answer was consumed.
    return this.mainPointsConsumed();
  };

  ECSmartOffer.prototype.evaluate = function () {
    if (!this.state || !this.state.quizCompleted) return;
    this.syncActiveReading();
    if (this.shown || this.isSuppressed()) return;

    if (this.mainPointsConsumed() && !this.guideMainPointsFired) {
      this.guideMainPointsFired = true;
      this.trackOnce('guide_main_points_viewed');
    }

    if (this.engagementMet() && !this.engagedFired) {
      this.engagedFired = true;
      this.trackOnce('quiz_destination_engaged');
      if (!this.guideEngagedFired) {
        this.guideEngagedFired = true;
        this.trackOnce('guide_engaged');
      }
    }

    if (!this.engagementMet()) return;

    if (!this.eligibleFired) {
      this.eligibleFired = true;
      writeFunnel({ smartOfferEligible: true });
      this.trackOnce('smart_offer_eligible');
    }

    // Eligibility must open the offer immediately — no extra click required.
    if (this.config.autoShow !== false && !this.shown) {
      this.show(false);
    }
  };

  ECSmartOffer.prototype.updateManual = function (visible) {
    if (!this.manual) return;
    var sess = readSession();
    var show = !!(this.config.showManualTrigger && visible && this.state && this.state.quizCompleted && !sess.smartOfferDismissed);
    this.manual.hidden = !show;
  };

  ECSmartOffer.prototype.show = function (manual) {
    if (!this.modal || this.shown) return;
    if (!manual && this.isSuppressed()) return;
    this.render();
    this.modal.hidden = false;
    this.shown = true;
    document.body.classList.add('ec-smart-offer-lock');
    writeFunnel({ smartOfferShown: true });
    writeSession({ smartOfferShownOnce: true });
    this.trackOnce('smart_offer_shown', { manual: !!manual });
    this.updateManual(false);
    var focus = this.modal.querySelector('[data-ec-so-autofocus], [data-ec-so-subscribe], [data-ec-so-soft]');
    if (focus) focus.focus();
  };

  ECSmartOffer.prototype.dismiss = function (reason) {
    if (!this.modal) return;
    this.modal.hidden = true;
    this.shown = false;
    document.body.classList.remove('ec-smart-offer-lock');
    writeFunnel({ smartOfferDismissed: true });
    writeSession({ smartOfferDismissed: true });
    if (reason === 'keep_reading') this.track('smart_offer_keep_reading');
    else this.track('smart_offer_dismissed');
    this.updateManual(true);
  };

  ECSmartOffer.prototype.render = function () {
    var product = this.state && this.state.commercialProduct;
    var soft = this.modal.querySelector('[data-ec-so-soft-wrap]');
    var offer = this.modal.querySelector('[data-ec-so-offer-wrap]');
    var heading = this.modal.querySelector('[data-ec-so-heading]');
    var body = this.modal.querySelector('[data-ec-so-body]');
    var eyebrow = this.modal.querySelector('[data-ec-so-eyebrow]');

    var page = this.pageOfferMeta();

    if (!product) {
      if (soft) soft.hidden = false;
      if (offer) offer.hidden = true;
      if (eyebrow) eyebrow.textContent = 'READY FOR THE NEXT STEP?';
      if (heading) heading.textContent = page.softHeading || 'Which format would you like to explore?';
      if (body) {
        body.textContent = page.intro ||
          'You’ve reviewed the information. Choose a format to continue — no subscription is recommended yet.';
      }
      return;
    }

    if (soft) soft.hidden = true;
    if (offer) offer.hidden = false;
    var titles = {
      resin: 'Want to start with Traditional Shilajit Resin?',
      capsules: 'Want to start with Shilajit Capsules?',
      atlas_x: 'Want to start with Atlas X?'
    };
    if (eyebrow) eyebrow.textContent = 'READY WHEN YOU ARE';
    if (heading) heading.textContent = titles[product] || 'Want to start?';
    var bodies = page.intro ||
      (CONCERN_BODY[this.state.route] || CONCERN_BODY[product] || {})[this.state.concern] ||
      'Now that you’ve reviewed the information, choose how you want to start.';
    if (body) body.textContent = bodies;

    this.renderOfferCard(product);
  };

  ECSmartOffer.prototype.renderOfferCard = function (product) {
    var c = this.commerceFor(product) || {};
    var title = this.modal.querySelector('[data-ec-so-offer-title]');
    var today = this.modal.querySelector('[data-ec-so-today]');
    var recurring = this.modal.querySelector('[data-ec-so-recurring]');
    var benefits = this.modal.querySelector('[data-ec-so-benefits]');
    var onePrice = this.modal.querySelector('[data-ec-so-onetime-price]');
    var subBtn = this.modal.querySelector('[data-ec-so-subscribe]');
    var oneBtn = this.modal.querySelector('[data-ec-so-onetime]');
    var err = this.modal.querySelector('[data-ec-so-error]');
    var subCard = this.modal.querySelector('[data-ec-so-sub-card]');
    var oneWrap = this.modal.querySelector('[data-ec-so-onetime-wrap]') || (oneBtn && oneBtn.parentElement);

    var first = c.firstPriceDisplay || '';
    var recur = c.recurringPriceDisplay || '';
    var one = c.oneTimePriceDisplay || '';
    var live = this.livePrices[product];
    if (live) {
      if (live.firstCents != null) first = money(live.firstCents);
      if (live.recurringCents != null) recur = money(live.recurringCents);
      if (live.oneTimeCents != null) one = money(live.oneTimeCents);
    }

    // Never show $0.00 / empty prices as commerce. Fail closed per option.
    var firstOk = isUsablePrice(first);
    var recurOk = isUsablePrice(recur);
    var oneOk = isUsablePrice(one);
    var subReady = !!(c.variantId && c.sellingPlanId && firstOk && recurOk);
    var oneReady = !!(c.variantId && oneOk);

    if (!subReady && !oneReady) {
      if (subCard) subCard.hidden = true;
      if (subBtn) subBtn.hidden = true;
      if (oneBtn) oneBtn.hidden = true;
      if (oneWrap && oneWrap !== subCard) oneWrap.hidden = true;
      if (err) {
        err.hidden = false;
        err.textContent = 'Purchase options are temporarily unavailable. Keep reading, or try again shortly.';
      }
      try { console.info('[ec-smart-offer] fail-closed: missing usable prices/plans', { product: product, first: first, recur: recur, one: one, sellingPlanId: c.sellingPlanId }); } catch (e) {}
      return;
    }

    if (title) title.textContent = c.offerTitle || 'Start with 50% off';
    if (today) today.textContent = firstOk ? first : '';
    if (recurring) {
      recurring.textContent = (subReady && recurOk)
        ? ('Then ' + recur + (c.cadenceLabel ? ' ' + c.cadenceLabel : ''))
        : '';
    }
    if (onePrice) onePrice.textContent = oneOk ? one : '';
    if (subBtn) subBtn.textContent = c.subscribeLabel || 'Start auto-replenishment';
    if (oneBtn) oneBtn.textContent = oneOk ? ((c.oneTimeLabel || 'Buy once') + ' — ' + one) : (c.oneTimeLabel || 'Buy once');

    var list = [];
    if (c.benefitsText) {
      list = String(c.benefitsText).split(/[\n|]+/).map(function (s) { return s.trim(); }).filter(Boolean);
    }
    if (!list.length) {
      list = [
        'Reminder before every charge',
        'Skip, pause or delay online',
        'Cancel online before the next charge'
      ];
    }
    if (benefits) {
      benefits.innerHTML = list.map(function (b) { return '<li>' + escapeHtml(b) + '</li>'; }).join('');
    }

    var priceRow = this.modal.querySelector('[data-ec-so-price-row]');
    if (priceRow) priceRow.hidden = !subReady;
    if (subCard) subCard.hidden = !subReady;
    if (subBtn) subBtn.hidden = !subReady;
    if (oneBtn) oneBtn.hidden = !oneReady;
    if (oneWrap && oneWrap !== subCard) oneWrap.hidden = !oneReady;
    if (err) {
      err.hidden = true;
      err.textContent = '';
    }

    this.prefetchLivePrices(product, c);
  };

  ECSmartOffer.prototype.prefetchLivePrices = function (product, c) {
    var self = this;
    if (!c || !c.productHandle) return;
    fetch('/products/' + encodeURIComponent(c.productHandle) + '.js', { credentials: 'same-origin' })
      .then(function (res) { if (!res.ok) throw new Error('product'); return res.json(); })
      .then(function (productJson) {
        var variants = productJson.variants || [];
        var variant = null;
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(c.variantId)) { variant = variants[i]; break; }
        }
        if (!variant) variant = variants[0];
        if (!variant) return;
        var info = { oneTimeCents: variant.price };
        if (c.sellingPlanId) {
          var allocs = variant.selling_plan_allocations || [];
          for (var j = 0; j < allocs.length; j++) {
            if (String(allocs[j].selling_plan_id) === String(c.sellingPlanId)) {
              var adjs = allocs[j].price_adjustments || [];
              info.firstCents = adjs[0] ? adjs[0].price : allocs[j].price;
              info.recurringCents = adjs[1] ? adjs[1].price : (adjs[0] ? adjs[0].price : allocs[j].price);
              break;
            }
          }
        }
        self.livePrices[product] = info;
        if (self.shown) self.renderOfferCard(product);
      })
      .catch(function () {});
  };

  ECSmartOffer.prototype.openConfirm = function () {
    var product = this.state.commercialProduct;
    var c = this.commerceFor(product) || {};
    var err = this.modal.querySelector('[data-ec-so-error]');
    if (!c.variantId || !c.sellingPlanId) {
      if (err) {
        err.hidden = false;
        err.textContent = 'Add a Shopify selling-plan ID in the homepage quiz settings before starting a subscription.';
      }
      this.track('smart_offer_subscription_clicked', { purchase_option: 'subscription', blocked: true });
      return;
    }
    this.track('smart_offer_subscription_clicked', { purchase_option: 'subscription' });
    var box = this.modal.querySelector('[data-ec-so-confirm]');
    if (!box) {
      this.confirmSubscription();
      return;
    }
    var today = this.modal.querySelector('[data-ec-so-confirm-today]');
    var recurring = this.modal.querySelector('[data-ec-so-confirm-recurring]');
    var cadence = this.modal.querySelector('[data-ec-so-confirm-cadence]');
    var next = this.modal.querySelector('[data-ec-so-confirm-next]');
    var live = this.livePrices[product] || {};
    if (today) today.textContent = (live.firstCents != null ? money(live.firstCents) : c.firstPriceDisplay) || '—';
    if (recurring) recurring.textContent = (live.recurringCents != null ? money(live.recurringCents) : c.recurringPriceDisplay) || '—';
    if (cadence) cadence.textContent = c.cadenceLabel || '';
    if (next) next.textContent = addDays(c.cadenceDays || 0);
    var ack = this.modal.querySelector('[data-ec-so-confirm-ack]');
    if (ack) ack.checked = false;
    box.hidden = false;
  };

  ECSmartOffer.prototype.closeConfirm = function () {
    var box = this.modal.querySelector('[data-ec-so-confirm]');
    if (box) box.hidden = true;
  };

  ECSmartOffer.prototype.confirmSubscription = function () {
    var self = this;
    var product = this.state.commercialProduct;
    var c = this.commerceFor(product) || {};
    var ack = this.modal.querySelector('[data-ec-so-confirm-ack]');
    var err = this.modal.querySelector('[data-ec-so-confirm-error]');
    if (ack && !ack.checked) {
      if (err) {
        err.hidden = false;
        err.textContent = 'Confirm that you understand this is a recurring order.';
      }
      return;
    }
    if (!c.variantId || !c.sellingPlanId) return;
    if (err) { err.hidden = true; err.textContent = ''; }

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{
          id: Number(c.variantId),
          quantity: 1,
          selling_plan: Number(c.sellingPlanId)
        }]
      })
    }).then(function (res) {
      if (!res.ok) throw new Error('cart');
      writeFunnel({ purchaseOptionClicked: 'subscription' });
      self.track('smart_offer_subscription_clicked', { purchase_option: 'subscription', confirmed: true });
      window.location.href = root + 'cart';
    }).catch(function () {
      if (err) {
        err.hidden = false;
        err.textContent = 'Could not add the subscription. Check the selling-plan ID and try again.';
      }
    });
  };

  ECSmartOffer.prototype.addOneTime = function () {
    var self = this;
    var product = this.state.commercialProduct;
    var c = this.commerceFor(product) || {};
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    this.track('smart_offer_one_time_clicked', { purchase_option: 'one_time' });
    if (!c.variantId) {
      var urls = (this.state && this.state.productUrls) || {};
      if (urls[product]) window.location.href = window.ECCanonicalProductUrl ? window.ECCanonicalProductUrl(urls[product]) : urls[product];
      return;
    }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(c.variantId), quantity: 1 }] })
    }).then(function (res) {
      if (!res.ok) throw new Error('cart');
      writeFunnel({ purchaseOptionClicked: 'one_time' });
      window.location.href = root + 'cart';
    }).catch(function () {
      var urls = (self.state && self.state.productUrls) || {};
      if (urls[product]) window.location.href = window.ECCanonicalProductUrl ? window.ECCanonicalProductUrl(urls[product]) : urls[product];
    });
  };

  ECSmartOffer.prototype.submitEmail = function () {
    var self = this;
    var input = this.modal.querySelector('[data-ec-so-email-input]');
    var consent = this.modal.querySelector('[data-ec-so-consent]');
    var err = this.modal.querySelector('[data-ec-so-email-error]');
    var status = this.modal.querySelector('[data-ec-so-email-status]');
    var email = input ? input.value : '';
    function setError(msg) {
      if (err) { err.hidden = !msg; err.textContent = msg || ''; }
    }
    if (!validEmail(email)) { setError('Enter a valid email address.'); return; }
    if (this.config.requireConsent && consent && !consent.checked) {
      setError('Confirm consent to continue.');
      return;
    }
    if (!this.config.klaviyo || !this.config.klaviyo.publicKey || !this.config.klaviyo.listId) {
      setError('Email capture is not configured.');
      return;
    }
    setError('');
    if (status) { status.hidden = true; status.textContent = ''; }

    var attributes = {
      email: email.trim(),
      ec_quiz_route: this.state.route,
      ec_quiz_concern: this.state.concern,
      ec_quiz_source: 'smart_offer'
    };
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: this.config.klaviyo.customSource || 'Essencraft Smart Offer',
          profile: { data: { type: 'profile', attributes: attributes } }
        },
        relationships: {
          list: { data: { type: 'list', id: this.config.klaviyo.listId } }
        }
      }
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(this.config.klaviyo.publicKey), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Revision: this.config.klaviyo.revision || '2024-10-15'
      },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!(res.status === 202 || res.status === 200 || res.status === 201)) throw new Error('klaviyo');
      self.track('smart_offer_email_submitted');
      writeSession({ emailSubmitted: true });
      if (status) {
        status.hidden = false;
        status.textContent = self.config.emailSuccess || 'Sent. You can keep reading above.';
      }
    }).catch(function () {
      setError(self.config.emailFailure || 'Could not send right now. Please try again.');
    });
  };

  ECSmartOffer.prototype.destroy = function () {
    if (this.tick) window.clearInterval(this.tick);
    if (this.shown) this.dismiss('destroy');
  };

  function mount(root) {
    if (!root) return;
    if (instance && instance.destroy) instance.destroy();
    instance = new ECSmartOffer(root);
    try { window.__ecSmartOffer = instance; } catch (e) {}
  }

  function init() {
    mount(document.querySelector('[data-ec-smart-offer-root]'));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    var root = e.target.querySelector('[data-ec-smart-offer-root]') ||
      (e.target.hasAttribute && e.target.hasAttribute('data-ec-smart-offer-root') ? e.target : null);
    if (root) mount(root);
  });
})();
